import { render, staticRenderFns } from "./PgaOfferEvaluationTotalAmountsDiscountedDetails.vue?vue&type=template&id=034a1d3c&scoped=true&"
import script from "./PgaOfferEvaluationTotalAmountsDiscountedDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationTotalAmountsDiscountedDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PgaOfferEvaluationTotalAmountsDiscountedDetails.vue?vue&type=style&index=0&id=034a1d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034a1d3c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VFadeTransition,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('034a1d3c')) {
      api.createRecord('034a1d3c', component.options)
    } else {
      api.reload('034a1d3c', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationTotalAmountsDiscountedDetails.vue?vue&type=template&id=034a1d3c&scoped=true&", function () {
      api.rerender('034a1d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/details/sub-components/PgaOfferEvaluationTotalAmountsDiscountedDetails.vue"
export default component.exports